import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Marketplace\GetMarketplaceSpecificController::__invoke
* @see app/Http/Controllers/Marketplace/GetMarketplaceSpecificController.php
* @route '/api/marketplace/module/{module_id}'
*/
const GetMarketplaceSpecificController = (args: { module_id: string | number } | [module_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMarketplaceSpecificController.url(args, options),
    method: 'get',
})

GetMarketplaceSpecificController.definition = {
    methods: ["get","head"],
    url: '/api/marketplace/module/{module_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Marketplace\GetMarketplaceSpecificController::__invoke
* @see app/Http/Controllers/Marketplace/GetMarketplaceSpecificController.php
* @route '/api/marketplace/module/{module_id}'
*/
GetMarketplaceSpecificController.url = (args: { module_id: string | number } | [module_id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { module_id: args }
    }

    if (Array.isArray(args)) {
        args = {
            module_id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        module_id: args.module_id,
    }

    return GetMarketplaceSpecificController.definition.url
            .replace('{module_id}', parsedArgs.module_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Marketplace\GetMarketplaceSpecificController::__invoke
* @see app/Http/Controllers/Marketplace/GetMarketplaceSpecificController.php
* @route '/api/marketplace/module/{module_id}'
*/
GetMarketplaceSpecificController.get = (args: { module_id: string | number } | [module_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMarketplaceSpecificController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Marketplace\GetMarketplaceSpecificController::__invoke
* @see app/Http/Controllers/Marketplace/GetMarketplaceSpecificController.php
* @route '/api/marketplace/module/{module_id}'
*/
GetMarketplaceSpecificController.head = (args: { module_id: string | number } | [module_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetMarketplaceSpecificController.url(args, options),
    method: 'head',
})

export default GetMarketplaceSpecificController